// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3hpQ3","select":"styles_select__Mv4ka"};